import { Button } from "antd";
import styled from "styled-components";

export const Inner = styled.div`
	display: flex;
	min-height: 200px;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	gap: 30px;
`;

export const Section = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: top;
	${(props) =>
		props.isMobile
			? `
    flex-direction: column;
  `
			: `
    flex-direction: row;
  `}
	${(props) =>
		props.isMobile
			? `
    gap: 10px;
  `
			: `
    gap: 40px;
  `}
`;

export const AntdButton = styled(Button)`
	border-radius: 10px;
	padding: 20px;
`;
